import type { RouteRecordRaw } from 'vue-router'

// Routes of the "Ročno" module. Spread into the `routes` array of router/index.ts.
export const rocnoRoutes: RouteRecordRaw[] = [
  {
    path: '/rocno/nov',
    name: 'rocno-nov',
    component: () => import('@/views/rocno/NewEntry.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/rocno/evidenca',
    name: 'rocno-evidenca',
    component: () => import('@/views/rocno/Log.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/rocno/pregled',
    name: 'rocno-pregled',
    component: () => import('@/views/rocno/Overview.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/rocno/inventura',
    name: 'rocno-inventura',
    component: () => import('@/views/rocno/Stocktake.vue'),
    meta: { requiresAuth: true },
  },
]
